export var FireblocksBalanceSubstatus;
(function (FireblocksBalanceSubstatus) {
    FireblocksBalanceSubstatus["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    FireblocksBalanceSubstatus["INSUFFICIENT_FUNDS_FOR_FEE"] = "INSUFFICIENT_FUNDS_FOR_FEE";
    FireblocksBalanceSubstatus["SOURCE_BALANCE_ERROR"] = "SOURCE_BALANCE_ERROR";
    FireblocksBalanceSubstatus["INSUFFICIENT_RESERVED_FUNDING"] = "INSUFFICIENT_RESERVED_FUNDING";
})(FireblocksBalanceSubstatus || (FireblocksBalanceSubstatus = {}));
//# sourceMappingURL=fireblocks-substatus.enum.js.map